export default __webpack_public_path__ + "static/media/icon-arrow-right.9e19be64.svg";